<template>
  <div class="flex xl:flex-col flex-col sm:flex-row gap-4 xl:gap-7">
    <div v-for="[key, value] in data" :key="key" class="flex-1">
      <div
        class="
          bg-gray-100 bg-opacity-50
          hover:bg-opacity-100
          transition-all
          duration-200
          border border-gray-200
          flex flex-row
          rounded-md
          items-center
          px-4
          py-6
          gap-4
          shadow-sm
          relative
        "
      >
        <div
          class="
            w-10
            h-10
            bg-white
            border border-gray-100
            flex
            items-center
            justify-center
          "
        >
          <Icon
            v-if="key.includes('acceleration')"
            icon="mdi:speedometer"
            width="20"
            class="text-red-600"
          />

          <Icon
            v-else-if="key.includes('braking')"
            icon="mdi:car-brake-alert"
            width="20"
            class="text-orange-600"
          />

          <Icon
            v-else-if="key.includes('cornering')"
            icon="mdi:car-turbocharger"
            width="20"
            class="text-yellow-600"
          />

          <Icon
            v-else-if="
              key.includes('maintenance_cost') ||
              key.includes('cost_per_vehicle')
            "
            icon="mdi:cash-multiple"
            width="20"
            class="text-green-600"
          />

          <Icon
            v-else-if="key.includes('total_frequency')"
            icon="mdi:tools"
            width="20"
            class="text-blue-600"
          />

          <Icon
            v-else
            icon="mdi:information-outline"
            width="20"
            class="text-gray-600"
          />
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-sm">{{ $t(key) }}</span>
          <span
            class="font-bold flex items-center"
            v-html="getFormattedValue(key, value)"
          ></span>
        </div>
        <el-tag
          v-if="changes[getChangeKey(key)] !== null && shouldShowChangeTag(key)"
          effect="dark"
          class="absolute gap-1 left-4 card__box__tag !rounded-xl bottom-4"
          :type="getTagType(key)"
        >
          <span class="font-medium ltr">
            {{ getChangeValue(key).toFixed(0) }}%
          </span>
          <i
            class="text-xs"
            :class="{
              'el-icon-top': getChangeValue(key) > 0,
              'el-icon-bottom': getChangeValue(key) < 0,
            }"
          ></i>
        </el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2'

export default {
  props: ['data', 'changes'],
  components: {
    Icon,
  },
  methods: {
    getFormattedValue(key, value) {
      if (!value) return '<span>0</span>'

      // Convert costs from Rial to Toman (1 Toman = 10 Rials)
      if (key.includes('cost')) {
        const tomanValue = value / 10
        return `<span class='flex items-center'><span class='flex items-center gap-1'>${this.$options.filters.numberSeperator1(
          tomanValue
        )} </span></span><span class="text-xs mr-2 mt-1">${this.$t(
          'TOMAN'
        )}</span>`
      }

      return `<span>${this.$options.filters.numberSeperator(value)}</span>`
    },
    getChangeKey(key) {
      return key.replace('number_of_', '')
    },
    getChangeValue(key) {
      return this.changes[this.getChangeKey(key)] || 0
    },
    shouldShowChangeTag(key) {
      return key !== 'total_frequency'
    },
    getTagType(key) {
      const changeValue = this.getChangeValue(key)

      if (key.includes('harsh_') || key.includes('number_of_harsh_')) {
        return changeValue > 0 ? 'danger' : 'success'
      }

      if (key.includes('cost')) {
        return changeValue > 0 ? 'danger' : 'success'
      }

      return changeValue > 0 ? 'success' : 'danger'
    },
  },
}
</script>
<style scoped>
.card__box__tag {
  border-radius: 20px !important;
  height: auto;
  font-size: 10px;
  line-height: normal;
  padding: 2px 6px;
  min-width: 54px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
